<template>
  <div :id="name">
    <!-- <div id="nav"> -->
    <!-- <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> -->
    <!-- </div> -->
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return {
      name:'app',
    }
  }
};
</script>

<style lang="scss">

</style>
